import { render, staticRenderFns } from "./ReasonableExpectation.vue?vue&type=template&id=0942b70d"
import script from "./ReasonableExpectation.vue?vue&type=script&lang=js"
export * from "./ReasonableExpectation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports